export default {
  // Dashboard
  greeting: 'Dobrý den, {name}',
  defaultName: 'tady',
  memberSince: 'Členem od {date} ·',
  accountSettings: 'Nastavení účtu',
  verifyEmailTitle: 'Ověřte svůj e-mail',
  verifyEmailBody: 'Vaše e-mailová adresa zatím není ověřena. Ověřte ji a odemkněte nákupy až do výše 50 €.',
  resendVerification: 'Odeslat ověřovací e-mail znovu',
  emailSent: 'E-mail odeslán ✓',
  purchaseAccess: 'Přístup k nákupům',
  emailVerifiedCanPurchase: 'E-mail ověřen — můžete nakupovat položky až do výše 50 €',
  verifyEmailToPurchase: 'Ověřte e-mail pro nákupy až do výše 50 €',
  kycApprovedCanPurchase: 'KYC schváleno — můžete nakupovat položky nad 50 €',
  kycRequired: 'KYC vyžadováno pro nákupy nad 50 €',
  accessEmailLabel: 'E-mail ověřen',
  accessEmailHint: 'Nákupy až do výše 50 €',
  accessKycLabel: 'KYC schváleno',
  accessKycHint: 'Nákupy nad 50 €',
  requestKyc: 'Požádat o ověření KYC',
  productPending: 'Čekající produkt',
  viewAllOrders: 'Zobrazit všechny objednávky',
  noPendingProducts: 'Žádné čekající produkty.',
  wallet: 'Peněženka',
  topUp: 'Dobít',
  lastPurchase: 'Poslední nákup',
  viewOrders: 'Zobrazit objednávky',
  noPurchasesYet: 'Zatím žádné nákupy.',
  yourFavorites: 'Vaše oblíbené',
  viewMore: 'Zobrazit více',
  noFavoritesPrefix: 'Zatím žádné oblíbené.',
  browseTheCatalog: 'Procházejte katalog',
  noFavoritesSuffix: 'a klepněte na srdíčko u her, které se vám líbí.',

  // Wallet top-up modal
  topup: {
    eyebrow: 'Dobití peněženky',
    title1: 'Přidat',
    titleAccent: 'prostředky',
    title2: 'do peněženky',
    subtitle: 'Prostředky se přičtou okamžitě k vašemu zůstatku PixelKey a jsou ihned k použití.',
    accountStatus: 'Stav účtu',
    billingAdded: 'Fakturační adresa — přidána',
    billingMissing: 'Fakturační adresa — nepřidána',
    addBilling: 'Přidat fakturační adresu',
    kycVerified: 'KYC — ověřeno',
    kycMissing: 'KYC — neověřeno',
    requestKyc: 'Požádat o ověření KYC',
    statusNote: 'Vyžadováno pro nákupy nad 50 €.',
    currentBalance: 'Aktuální zůstatek',
    amountToAdd: 'Částka k přidání',
    newBalance: 'Nový zůstatek po dobití:',
    cancel: 'Zrušit',
    confirmPay: 'Potvrdit a zaplatit',
    redirectNote: 'Budete přesměrováni k našemu platebnímu poskytovateli.',
    rangeHint: 'Zadejte částku mezi {min} a {max}.',
    failed: 'Dobití se nepodařilo spustit. Zkuste to znovu.',
    returnPending: 'Potvrzujeme vaše dobití…',
    returnPendingText: 'Obvykle to trvá několik sekund.',
    returnSuccessPrefix: 'Dobití',
    returnSuccessAccent: 'dokončeno',
    returnSuccessText: 'Prostředky byly přidány do vaší peněženky.',
    returnFailedPrefix: 'Dobití',
    returnFailedAccent: 'selhalo',
    returnFailedText: 'Dobití se nepodařilo dokončit. Nic vám nebylo účtováno.',
    returnBalance: 'Nový zůstatek',
    returnToDashboard: 'Na dashboard',
    returnRetry: 'Zkusit znovu',
  },

  // Settings — tabs
  tabSettings: 'Nastavení',
  tabBilling: 'Fakturace',

  // Settings — personal info
  personalInformation: 'Osobní údaje',
  profileDetails: 'Údaje profilu',
  security: 'Zabezpečení',
  kycTradingLimits: 'Limity obchodování úrovně 1',
  fullName: 'Celé jméno',
  firstName: 'Jméno',
  lastName: 'Příjmení',
  emailAddress: 'E-mailová adresa',
  verified: 'Ověřeno',
  phoneNumber: 'Telefonní číslo',
  country: 'Země',
  birthDate: 'Datum narození',
  billingAddress: 'Fakturační adresa',
  streetAddress: 'Ulice a číslo',
  city: 'Město',
  postalCode: 'PSČ',
  saveChanges: 'Uložit změny',
  saving: 'Ukládání…',
  changesSaved: 'Změny uloženy.',
  couldNotSaveChanges: 'Změny se nepodařilo uložit.',

  // Settings — change password
  changePassword: 'Změnit heslo',
  currentPassword: 'Současné heslo',
  newPassword: 'Nové heslo',
  passwordHint: 'Musí mít alespoň 8 znaků, písmeno a číslici.',
  confirmNewPassword: 'Potvrďte nové heslo',
  updatePassword: 'Aktualizovat heslo',
  updating: 'Aktualizace…',
  passwordUpdated: 'Heslo aktualizováno.',
  passwordsDoNotMatch: 'Nová hesla se neshodují.',
  passwordTooWeak: 'Heslo musí mít alespoň 8 znaků, písmeno a číslici.',
  couldNotUpdatePassword: 'Heslo se nepodařilo aktualizovat.',

  // Settings — KYC
  kycVerification: 'Ověření KYC',
  verifiedAccount: 'Ověřený účet',
  unverifiedAccount: 'Neověřený účet',
  pendingReview: 'Čeká na kontrolu',
  rejectedAccount: 'Ověření zamítnuto',
  kycDescription: 'Ověření je vyžadováno pro nákupy vyšší úrovně a obchodování na tržišti.',
  kycAttachHint: 'Volitelně přiložte doklad totožnosti (PDF/JPG/PNG, max. 3 soubory, 5 MB každý).',
  kycSubmitting: 'Odesílání…',
  kycRequestSent: 'Žádost o ověření byla odeslána. Administrátor ji brzy zkontroluje.',
  kycRequestFailed: 'Žádost o ověření se nepodařilo odeslat. Zkuste to znovu.',

  // Settings — danger zone
  dangerZone: 'Nebezpečná zóna',
  deletionScheduled: 'Váš účet je naplánován ke smazání dne {date}. Do té doby můžete smazání zrušit.',
  cancelDeletion: 'Zrušit smazání',
  cancelling: 'Rušení…',
  deleteConfirmPrompt: 'Jste si jisti? Váš účet bude trvale smazán po 7denní ochranné lhůtě.',
  confirm: 'Potvrdit',
  working: 'Probíhá…',
  keepAccount: 'Ponechat účet',
  deleteAccountDescription: 'Trvale smaže váš účet a odstraní všechna data. Tuto akci nelze po 7 dnech vrátit zpět.',
  deleteAccount: 'Smazat účet',

  // Favorites page
  favoritesTitle: 'Vaše oblíbené',
  favoritesSubtitle: 'Hry, které jste si uložili na později.',
  noFavoritesTitle: 'Zatím žádné oblíbené',
  favoritesLoadFailed: 'Vaše oblíbené se nepodařilo načíst. Zkuste to prosím znovu.',
  favoritesEmptyHint: 'Klepnutím na srdíčko u libovolné hry ji sem uložíte.',
  browseCatalog: 'Procházet katalog',

  // Billing page
  billing: {
    title: 'Platby',
    subtitle: 'Peněženka, transakce a historie nákupů.',
    availableBalance: 'Dostupný zůstatek',
    fundsUsable: 'Prostředky lze použít na jakoukoli položku katalogu.',
    topUpWallet: 'Dobít peněženku',
    purchaseHistory: 'Historie nákupů',
    walletLedger: 'Kniha peněženky',
    allTransactions: 'Všechny transakce',
    colDate: 'Datum',
    colProduct: 'Produkt',
    colPrice: 'Cena',
    colInvoice: 'Faktura',
    colType: 'Typ',
    colDescription: 'Popis',
    colAmount: 'Částka',
    download: 'Stáhnout',
    noPurchases: 'Zatím žádné nákupy.',
    noLedger: 'Zatím žádné transakce peněženky.',
  },
};
